import { LogoutUsecase } from '.'

export class LoginFromTokenUsecase extends LogoutUsecase {
    loginBrowserFromToken (): boolean {
        const tokenOrError = this.browserService.extractURLAuthentication()

        if (tokenOrError === null) {
            /** There is no token, give up */
            return false
        }

        if (typeof tokenOrError === 'string') {
            /** Attempt to fetch the session, load it, and then drop the args from the URL */
            void this.updateAuthenticationFromToken(tokenOrError).then(() => this.browserService.removeURLAuthentication())
        } else {
            this.updateAuthentication(tokenOrError)
        }

        return true
    }
}
